/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {combineReducers} from 'redux';
import dashboard from './dashboard';
import errors from './errors';
import initialization from './initialization';
import login from './login';
import nav from './nav';
import userPrompt from './user-prompt';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export type {ApplicationState} from '@/types/redux';

/**
 * Defines the root reducer which is a composite of all application specific
 * reducers via combineReducers.
 */
const rootReducer = combineReducers({
  initialization,
  errors,
  login,
  nav,
  dashboard,
  userPrompt
});
export default rootReducer;
